export default {
  ACCESS_TOKEN: sessionStorage.getItem('ACCESS_TOKEN'),
  currentUser: null,
  listProvinces: [],
  listDistricts: [],
  listWards: [],
}
